import { ViewConfig } from "@lib/views";
import {
    DATE_COLUMN_SIZE,
    AMOUNT_COLUMN_SIZE,
} from "@design-system/ViewTable/DefaultColumnSizes";
import { HistoryDetailsBaseRow } from "../../cells/historyDetailsBaseRow";
import { HistoryDetailsAmountCell } from "../../cells/HistoryDetailsAmountCell";
import { HistoryDetailsEntityCell } from "../../cells/HistoryDetailsEntityCell";
import { HistoryDetailsExpandCell } from "../../cells/HistoryDetailsExpandCell";
import { JournalEntryListDateCell } from "../cells/JournalEntryListDateCell";
import { JournalEntryReferenceCell } from "../cells/JournalEntryReferenceCell";
import { JournalEntryExcludeFrom1099Cell } from "../cells/JournalEntryExcludeFrom1099Cell";

export interface JournalEntryListRow extends HistoryDetailsBaseRow {
    id: string;
    sourceId: string;
    reference: string;
    source: string;
    amount: number;
    originalAmount: number;
    excludeFrom1099: boolean;
}

export enum JournalEntryListColumn {
    REFERENCE = "reference",
    DATE = "date",
    SOURCE = "source",
    AMOUNT = "amount",
    ENTITY = "entity",
    EXCLUDE_FROM_1099 = "excludeFrom1099",
    ACTIONS = "actions",
}

export const journalEntryListViewConfig: ViewConfig<
    JournalEntryListRow,
    JournalEntryListColumn,
    never
> = {
    columns: {
        [JournalEntryListColumn.REFERENCE]: {
            accessorKey: "reference",
            name: "Reference",
            header: "Reference",
            cell: JournalEntryReferenceCell,
            minSize: 120,
            maxSize: 200,
        },
        [JournalEntryListColumn.DATE]: {
            accessorKey: "date",
            name: "Date",
            header: "Date",
            cell: JournalEntryListDateCell,
            ...DATE_COLUMN_SIZE,
        },
        [JournalEntryListColumn.SOURCE]: {
            accessorKey: "source",
            name: "Source",
            header: "Source",
            minSize: 120,
            maxSize: 250,
        },
        [JournalEntryListColumn.AMOUNT]: {
            accessorKey: "amount",
            name: "Amount",
            header: "Amount",
            cell: HistoryDetailsAmountCell,
            ...AMOUNT_COLUMN_SIZE,
        },
        [JournalEntryListColumn.ENTITY]: {
            accessorKey: "entity",
            name: "Entity",
            header: "Entity",
            cell: HistoryDetailsEntityCell,
            minSize: 56,
            maxSize: 150,
        },
        [JournalEntryListColumn.EXCLUDE_FROM_1099]: {
            accessorKey: "excludeFrom1099",
            name: "Exclude from 1099",
            header: "Exclude from 1099",
            cell: JournalEntryExcludeFrom1099Cell,
            minSize: 120,
            maxSize: 160,
        },
        [JournalEntryListColumn.ACTIONS]: {
            accessorKey: "id",
            name: "Actions",
            header: "",
            cell: HistoryDetailsExpandCell,
            minSize: 56,
            maxSize: 56,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
};
